import React from 'react';
import { FlexCol, FlexRow, TitleSmall } from '../../../common/components/v2';
import { Resource } from '../../../common/constants/resource';
import { TaskState } from '../../../common/constants/states';
import { getFormattedTimestamp } from '../../../common/helpers';
import { ITask } from '../../tasks/interfaces/ITask';
import styles from '../styles.module.scss';
import { NoraTaskIcon } from './components/NoraTaskIcon';

export const TaskEmptyDetail = ({
  task,
  taskStateHandler,
  resourceName,
  locator,
}: {
  task: ITask;
  taskStateHandler: (taskId: number, state: TaskState, reason?: string) => void;
  resourceName: string;
  locator: string;
}) => {
  const onTaskStateChange = async (state: TaskState, reason?: string) => {
    if (state) {
      taskStateHandler(task.id, state, reason);
    }
  };

  return (
    <div data-label={locator}>
      <FlexRow id={task.id.toString()} className={styles.Title}>
        <FlexCol className={styles.TitleTaskIcon}>
          <NoraTaskIcon task={task} onTaskStateClick={onTaskStateChange} />
        </FlexCol>
        <TitleSmall>{resourceName}</TitleSmall>
        <FlexCol className={styles.CreatedDate}>
          {getFormattedTimestamp(task.retriedAt ?? task.createdAt)}
        </FlexCol>
      </FlexRow>
      {task.state === TaskState.WAIVED && task.waiveReason && (
        <FlexRow className={styles.TaskSubtitle}>
          <strong>{Resource.WAIVE_REASON}:</strong>&nbsp;{task.waiveReason}
        </FlexRow>
      )}
    </div>
  );
};
